import { useState, useCallback } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { env } from "@/config/environment";

const PAGE_TITLES: Record<string, string> = {
  "/": "Dashboard",
  "/activity": "Activity",
  "/users": "Users",
  "/credits": "Credits",
  "/analytics": "Analytics",
  "/funnel": "Funnel",
  "/deploy-history": "Deploy History",
  "/dev-replication": "Dev Replication",
  "/dev-refresh": "Dev Refresh",
};

interface LayoutProps {
  onLogout: () => void;
}

export function Layout({ onLogout }: LayoutProps) {
  const location = useLocation();
  const basePath = "/" + (location.pathname.split("/")[1] ?? "");
  const pageTitle = PAGE_TITLES[basePath] ?? "Dashboard";
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);

  return (
    <>
      <div className="theatre" />
      <div className="screen">
        <button
          className="mobile-menu-toggle"
          onClick={() => setSidebarOpen(o => !o)}
          aria-label="Toggle navigation"
        >
          &#9776;
        </button>
        {sidebarOpen && <div className="sidebar-overlay open" onClick={closeSidebar} />}

        {/* Sidebar */}
        <nav className={`sidebar${sidebarOpen ? " open" : ""}`} onClick={(e) => {
          if ((e.target as HTMLElement).closest("a")) closeSidebar();
        }}>
          <div className="sidebar-brand">
            <h1>Previs Pro</h1>
            <p>Administration</p>
          </div>

          <NavLink to="/" end className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}>
            <span className="nav-icon">&#9670;</span> Dashboard
          </NavLink>
          <NavLink to="/activity" className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}>
            <span className="nav-icon">&#9202;</span> Activity
          </NavLink>
          <NavLink to="/users" className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}>
            <span className="nav-icon">&#9734;</span> Users
          </NavLink>
          <NavLink to="/credits" className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}>
            <span className="nav-icon">&#9673;</span> Credits
          </NavLink>
          <NavLink to="/analytics" className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}>
            <span className="nav-icon">&#9683;</span> Analytics
          </NavLink>
          <NavLink to="/funnel" className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}>
            <span className="nav-icon">&#9662;</span> Funnel
          </NavLink>
          {!env.isDev && (
            <>
              <NavLink to="/deploy-history" className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}>
                <span className="nav-icon">&#9881;</span> Deploy History
              </NavLink>
              <NavLink to="/dev-replication" className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}>
                <span className="nav-icon">&#9883;</span> Dev Replication
              </NavLink>
              <NavLink to="/dev-refresh" className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}>
                <span className="nav-icon">&#8635;</span> Dev Refresh
              </NavLink>
            </>
          )}

          <div className="sidebar-footer">
            <button className="logout-btn" onClick={onLogout}>
              Sign Out
            </button>
          </div>
        </nav>

        {/* Main */}
        <div className="main-content">
          <header className="topbar">
            <div className="topbar-title">
              Now Showing: <span>{pageTitle}</span>
            </div>
          </header>
          <div className="page-content">
            <div className="page-enter" key={basePath}>
              <Outlet />
            </div>
          </div>
        </div>

        <div className="screen-corners-bottom" />
      </div>
    </>
  );
}
